import { Flex, Modal, Select, Typography } from 'antd';

import {
  useCopyEmployeeServicesModal,
  useCopyEmployeeServicesModalEffects,
} from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/CopyEmployeeServicesModal/hooks';

import type { FC } from 'react';

const { Text } = Typography;

interface CopyEmployeeServicesModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  employeeId: number;
}

export const CopyEmployeeServicesModal: FC<CopyEmployeeServicesModalProps> = ({
  isOpen,
  setIsOpen,
  employeeId,
}) => {
  const {
    selectedEmployeeId,
    setSelectedEmployeeId,
    employeesOptions,
    employeesError,
    isEmployeesFetching,
    closeModalHandler,
    navigateToEmployeeHandler,
  } = useCopyEmployeeServicesModal({ isOpen, setIsOpen, employeeId });

  useCopyEmployeeServicesModalEffects({ employeesError });

  return (
    <Modal
      open={isOpen}
      onCancel={closeModalHandler}
      title="Копировать услуги исполнителя"
      okText="Перейти к выбранному исполнителю"
      onOk={navigateToEmployeeHandler}
      okButtonProps={{
        disabled: !selectedEmployeeId,
      }}
    >
      <Flex vertical gap={16}>
        <Text>
          Выберите исполнителя, которому хотите скопировать услуги. Услуги будут
          скопированы вместе с длительностью и заработной платой и заменят
          текущие услуги выбранного исполнителя после сохранения.
        </Text>
        <Select
          options={employeesOptions}
          loading={isEmployeesFetching}
          allowClear
          showSearch
          optionFilterProp="filterName"
          placeholder="Выберите исполнителя"
          value={selectedEmployeeId}
          onChange={setSelectedEmployeeId}
        />
      </Flex>
    </Modal>
  );
};
